import { Routes, Route } from "react-router-dom";
import ReturnPath from "components/routes/ReturnPath";
import Cargos from "./Cargos";
import CargoCreateEdit from "./CargoCreateEdit";
import CargoDetails from "./CargoDetails";

const index = () => {
	return (
		<Routes>
			<Route element={<ReturnPath primaryPath="cargos" />}>
				<Route index element={<Cargos />} />
				<Route path='/create' element={<CargoCreateEdit />} />
				<Route path='/:id/edit' element={<CargoCreateEdit />} />
				<Route path='/:id/details' element={<CargoDetails />} />
			</Route>
		</Routes>
	);
};

export default index;
